import { render, staticRenderFns } from "./TbodyLoading.vue?vue&type=template&id=a6b5a2b8"
import script from "./TbodyLoading.vue?vue&type=script&lang=js"
export * from "./TbodyLoading.vue?vue&type=script&lang=js"
import style0 from "./TbodyLoading.vue?vue&type=style&index=0&id=a6b5a2b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports